import { BehaviorSubject, combineLatest } from "rxjs";
import { distinctUntilChanged, filter, map } from "rxjs/operators";
import { container, singleton } from "tsyringe";
import { PTApiService } from "./ptapi-service";
import { PTSocketService } from "./ptsocket.service";
import { SEAMApiService } from "./seamapi-service";
import { UserService } from "./user-service";
import { WebRTCsdkService } from "./webrtcsdk-service";

@singleton()
export class OrchestratorService {

    private meetingInitialized$ = new BehaviorSubject<boolean>(false);

    // using DI in constructor would require to eject the app
    private userService = container.resolve(UserService);
    private ptSocketService = container.resolve(PTSocketService);
    private seamApiService = container.resolve(SEAMApiService);
    private ptApiService = container.resolve(PTApiService);
    private webRTCsdkService = container.resolve(WebRTCsdkService);

    get meetingInitializedObservable() {
        return this.meetingInitialized$.pipe(filter(i => !!i));
    }

    constructor() {
        combineLatest([
            this.ptSocketService.socketConnectedObservable.pipe(
                filter(socketGuid => !!socketGuid),
                distinctUntilChanged()
            ),
            this.webRTCsdkService.selfParticipantObservable.pipe(
                map(selfParticipant => selfParticipant?.participantGuid),
                filter(selfParticipantGuid => !!selfParticipantGuid),
                distinctUntilChanged()
            )
        ]).subscribe(async ([socketGuid, selfParticipantGuid]) => {
            if (!(await this.seamApiService.ensureRequiredFeaturesEnabled()) || this.meetingInitialized$.value) {
                return;
            }

            await this.ptApiService.registerAsModerator(socketGuid, selfParticipantGuid);

            this.meetingInitialized$.next(true);
        });
    }

    leaveMeeting() {
        this.meetingInitialized$.next(false);
        this.webRTCsdkService.leaveMeeting();
        this.ptSocketService.disconnectSocket();
    }
}